import { NumberParam, useQueryParam } from 'use-query-params';
import { NumberInput } from '../../../../components/shared/input/Input';
import { QueryParamNames } from '../../enums/QueryParamNames';

export function DensityFilter() {
    const [minDensity, setMinDensity] = useQueryParam(QueryParamNames.MIN_DENSITY, NumberParam);
    const [maxDensity, setMaxDensity] = useQueryParam(QueryParamNames.MAX_DENSITY, NumberParam);

    return (
        <div className='col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-2'>
            <p>Density:</p>
            <div className='flex items-center'>
                <NumberInput min='0' value={minDensity ?? null} onChange={setMinDensity} />
                <p className='m-0 mx-2'>to</p>
                <NumberInput min='0' value={maxDensity ?? null} onChange={setMaxDensity} />
            </div>
        </div>
    );
}
